import ComponentModule from "@eisinc/Overrides/Components/PageBreadcrumbs";

export * from "@eisinc/Overrides/Components/PageBreadcrumbs";

export default ComponentModule;
